import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=18920910&scoped=true&"
import script from "./StoreInfo.vue?vue&type=script&lang=js&"
export * from "./StoreInfo.vue?vue&type=script&lang=js&"
import style0 from "../../less/store.less?vue&type=style&index=0&id=18920910&lang=less&scoped=true&"
import style1 from "./StoreInfo.vue?vue&type=style&index=1&id=18920910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18920910",
  null
  
)

export default component.exports